import { LyfshortUserProfile } from "../types/authState";
import { appServerFetch } from "./api";

const APP_SERVER_BASE_URL = "https://dev-dot-lyf-short.appspot.com";

/**
 * Interfaces for API responses
 */
interface SigninRes {
  isNewUser: boolean,
  user: LyfshortUserProfile,
}

interface UsernameAvailabilityResponse {
  available: boolean;
}

/**
 * Fetch user sign-in details.
 */
export async function getUserSignin(accessToken: string): Promise<SigninRes> {
  const url = `${APP_SERVER_BASE_URL}/users/signin`;
  return appServerFetch<SigninRes>(url, "GET", accessToken);
}

/**
 * Update user information.
 */
export async function updateUser(user: Partial<LyfshortUserProfile>, accessToken: string): Promise<LyfshortUserProfile> {
  const url = `${APP_SERVER_BASE_URL}/users`;
  return appServerFetch<LyfshortUserProfile>(url, "PUT", accessToken, user);
}

/**
 * Check if the user's email is verified.
 */
export async function checkUserEmailVerification(accessToken: string): Promise<{ verified: boolean, user: LyfshortUserProfile }> {
  const url = `${APP_SERVER_BASE_URL}/check-user-email-verification`;
  return appServerFetch<{ verified: boolean, user: LyfshortUserProfile }>(url, "POST", accessToken, {});
}

/**
 * Check if a username is available.
 */
export async function usernameAvailability(username: string): Promise<UsernameAvailabilityResponse> {
  const url = `${APP_SERVER_BASE_URL}/users/username-availability?username=${encodeURIComponent(username)}`;
  return appServerFetch<UsernameAvailabilityResponse>(url, "GET");
}